const DAY = 86_400_000;
const berlinDate = new Intl.DateTimeFormat("sv-SE", {
  timeZone: "Europe/Berlin",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

export function berlinDayKey(ms: number): string {
  return berlinDate.format(new Date(ms));
}

/** UTC noon stays on the intended Berlin date on both sides of every DST change. */
export function calendarDaysForBerlinDate(today: string, count = 14): number[] {
  const firstNoon = Date.parse(`${today}T12:00:00.000Z`);
  return Array.from({ length: count }, (_, index) => firstNoon + index * DAY);
}
